<template>
  <div class="header">
    <tvu-top-header
      projectName="Remote Commentator"
      :globalFunList="['waffle','account', 'helpCenter' ]"
      :multiAccountList="multiAccountList"
      :userAuthUrl="Config.urlInfo.userAuthUrl"
      theme="dark"
      :versionServiceNameList="serviceNameList"
      :serviceVesion="[{
        serviceName: 'Remote Commentator',
        frontendVersion: fontendVersion,
        backendVersion: backendVersion,
        tagName: $store.state.config.applicationName
      }]"
      @callback="topHeaderCallback">
      <!-- 自定用账号下拉的中间模块 -->
      <template #account-center-module>
        <div class="contaniner login-info">
          <!-- 云代理按钮 -->
          <div class="settings-entry" v-if="$route.name == 'commentator'" @click="showSettingInfo.show = true">
            <div class="left">{{$t('coordinationRoom.settingName')}}</div>
          </div>
          <div class="enterAddCoHostCohost" @click="showAddCoHostPop">
            <div class="left">{{$t('coHost.coHostTitle')}}</div>
            <span class="info">
              <el-tooltip popper-class="collaborate" placement="bottom" :visible-arrow="false">
                <i style="color: #6D6D6D;" class="iconfont icon-help2"></i>
                <div slot="content">
                  <p class="text" style="width: 350px;">{{ $t("coHost.equlText") }}</p>
                </div>
              </el-tooltip>
            </span>
            <div class="right">
                <div style="display: inline-block;" v-for="(item, index) in State.hadInvite" :key="index" >
                  <span class="invitedPerson" :style="{'background':item.color }">{{ item.email }}</span>
                </div>
            </div>
          </div>
          <div class="language" v-if="State.switchLang">
            <div class="left">
              {{$t('personalInfo.lang')}}
            </div>
            <div class="right">
              <span
                :class="{ zhColor: $i18n.locale === 'zh'}"
                @click="changeLanguage('en')"
                >EN</span
              >
              <span class="second">/</span>
              <span
                :class="{ zhColor: $i18n.locale !== 'zh' }"
                @click="changeLanguage('zh')"
                >中文</span
              >
            </div>
          </div>
          <div class="usagePage" v-if="$route.name!= 'usage'">
            <a  class="left" style="width: 270px;" :href="`${protocol}//${domain}/commentator/usage`" target="_blank">
              {{$t('personalInfo.usagePage')}}
            </a>
          </div>
        </div>
      </template>
      <template #top-header-middle>
        <div class="countDown" v-if="isShowCountDown">
          <p class="title">{{$t('eventList.countDown')}}</p>
          <p class="digitalCount">
            <span class="mins">{{countDownTime.mins }}</span>
            <span class="colon">:</span>
            <span class="seconds">{{countDownTime.seconds}}</span>
          </p>
        </div>
      </template>
      <!-- 自定义整个服务的私有功能（可以包括或者不包括多账号ui， 提供默认样式） -->
      <template #right-app-module v-if="$route.name != 'usage'">
         <!-- 显示网络状况 -->
        <div class="item-fun" v-if="$route.name == 'coordination'">
        <div class="netWorkTip">
          <el-popover popper-class="netWorkTips" effect="dark" placement="bottom-start" :visible-arrow="false">
            <div>
              <h6>{{$t('personalInfo.bandWidth')}}</h6>
              <p class="upLink">
                <i class="el-icon-top" :class="colorUp"></i>
                <span :class="colorUp">{{$t(`personalInfo.${netWork.upLinkNetWork}`)}}</span>
              </p>
              <p class="downLink">
                <i class="el-icon-bottom" :class="colorDown"></i>
                <span :class="colorDown">{{$t(`personalInfo.${netWork.downLinkNetWork}`)}}</span>
              </p>
            </div>
            <NetWorkQuality slot="reference" @callback="showNetWork"></NetWorkQuality>
          </el-popover>
        </div>
        </div>
      </template>
    </tvu-top-header>
    <Setting
      :info="showSettingInfo"
      @close="showSettingInfo.show = false"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Cookie from 'js-cookie'
import NetWorkQuality from '@/components/common/netWorkQuality'
import { loadSudoku } from '@/assets/js/loadSudoku.js'
import Tools from '@/assets/js/utils.js'
import Setting from '@/views/commentator/dialog/setting'
export default {
  components: {
    NetWorkQuality,
    Setting
  },
  data () {
    return {
      showSettingInfo: {
        show: false
      },
      protocol: window.location.protocol,
      domain: document.domain,
      multiAccountList: [],
      netWork: {
        upLinkNetWork: 'Good',
        downLinkNetWork: 'Good'
      },
      serviceNameList: [],
      partyCode: '',
      eventId: '',
      AudioMixer: {
        tagName: '',
        backendVersion: '',
        frontendVersion: ''
      },
      Producer: {
        tagName: '',
        backendVersion: '',
        frontendVersion: ''
      },
      MediaService: {
        tagName: '',
        backendVersion: '',
        frontendVersion: ''
      },
      Partyline: {
        tagName: '',
        backendVersion: '',
        frontendVersion: ''
      },
      fontendVersion: '',
      userId: '',
      backendVersion: '',
      countDownTime: {
        mins: '',
        seconds: ''
      },
      isShowCountDown: false,
      timeIntervals: null,
      startCountDownStamp: 20 * 60 * 1000,
      logoSvg: ''
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      Config: (state) => state.config,
      userInfo: (state) => state.userInfo,
      websocket: (state) => state.socket
    }),
    colorUp () {
      if (!this.netWork.upLinkNetWork) return ''
      if (this.netWork.upLinkNetWork === 'Good') {
        return 'colorGreen'
      } else if (this.netWork.upLinkNetWork === 'Mid') {
        return 'colorOrange'
      } else if (this.netWork.upLinkNetWork === 'Poor') {
        return 'colorRed'
      } else {
        return 'colorGreen'
      }
    },
    colorDown () {
      if (!this.netWork.downLinkNetWork) return ''
      if (this.netWork.downLinkNetWork === 'Good') {
        return 'colorGreen'
      } else if (this.netWork.downLinkNetWork === 'Mid') {
        return 'colorOrange'
      } else if (this.netWork.downLinkNetWork === 'Poor') {
        return 'colorRed'
      } else {
        return 'colorGreen'
      }
    }
  },
  watch: {
    'State.dataEndTime': {
      handler (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.startCountDown(newVal)
          })
        }
      },
      immediate: true
    }
  },
  async created () {
    // 显示各个依赖服务的版本号
    const that = this
    this.serviceNameList = this.$store.state.config.serviceNames
    this.$backAndFrontVersion({
      ...this.$TVU,
      params: {
        serviceNameList: this.serviceNameList
      },
      success: function (val) {
        val.forEach((vals, index, val_arr) => {
          if (val_arr[index].serviceName == 'Producer') {
            that.Producer = val_arr[index]
          } else if (val_arr[index].serviceName == 'Partyline') {
            that.Partyline = val_arr[index]
          } else if (val_arr[index].serviceName == 'Audio Mixer') {
            that.AudioMixer = val_arr[index]
          } else {
            that.MediaService = val_arr[index]
          }
        });
      },
      error: function (val) {
      }
    })
    loadSudoku()
    this.getRegion()
    this.userId = await this.$store.dispatch('isLogin')
    await this.$store.dispatch('getUserType')
    // 显示前端版本号
    let frontVersion = localStorage.getItem('partylineCommentatorVersion')
    if (frontVersion && frontVersion.includes('_')) {
      frontVersion = frontVersion.substring(0, frontVersion.indexOf('_'))
    }
    this.fontendVersion = 'Front ' + frontVersion
    // 获取后端版本号
    await this.$store.dispatch('getBackEndVersion')
    let backVersion = localStorage.getItem('backendVersion')
    if (backVersion && backVersion.includes('_')) {
      backVersion = backVersion.substring(0, backVersion.indexOf('_'))
    }
    this.backendVersion = 'Backend ' + backVersion
    // 创建Websocket
  },
  mounted () {
    this.logoSvg = `#${this.State.commonLogo}`
    this.getEmailColor()
  },
  methods: {
    getEmailColor () {
      this.$http.get(`https://${this.State.config.urlInfo.userAuthUrl}/main/getUserProfile`, { errorTips: false })
        .then(res => {
          if (res.data.errorCode === '0x0') {
            if (res.data.result) {
              this.State.avatarColor = res.data.result.profileColor
            }
          }
        })
    },
    showAddCoHostPop () {
      this.State.addCoHost = true
    },
    topHeaderCallback (info) {
      const { type } = info
      if (type === 'signOut') {
        this.logout()
      }
    },
    showNetWork (netWork) {
      this.netWork.upLinkNetWork = netWork.upLinkNetWork
      this.netWork.downLinkNetWork = netWork.downLinkNetWork
    },
    changeLanguage (lang) {
      Cookie.set('userLanguage', lang, { domain: '.tvunetworks.com' })
      this.$i18n.locale = lang
      this.State.browserLanguage = lang
    },
    getRegion () {
      const region = localStorage.getItem('region')
      if (region) return
      this.$http.get('/commentator-backend/user/region').then((res) => {
        if (res.data.errorCode == '0x0') {
          localStorage.setItem('region', res.data.result)
        }
      })
    },
    logout () {
      let domain = '.tvunetworks.com'
      if (!location.host.includes(domain)) {
        domain = '.tvunetworks.cn'
      }
      this.$http.get('/commentator-backend/user/logout').then((res) => {
        if (res.data.errorCode == '0x0') {
          window.location.href = `${this.Config.urlInfo.userservice}/?url=${location.protocol}//${location.host}/commentator&serviceName=${this.Config.serverName}`
        }
      })
    },
    startCountDown (endTimeStamp) {
      let currentTime
      if (this.timeIntervals) {
        clearInterval(this.timeIntervals)
      }
      this.timeIntervals = setInterval(() => {
        currentTime = new Date().getTime()
        if ((endTimeStamp - currentTime) < this.startCountDownStamp) {
          this.countDownTime = { ...Tools.countDown(endTimeStamp) }
          this.isShowCountDown = true
          if (typeof this.countDownTime.seconds === 'string') {
            if (this.countDownTime.seconds.indexOf('-') > -1) {
              this.isShowCountDown = false
            }
          }
        } else {
          this.isShowCountDown = false
        }
      }, 1000)
    }
  },
  beforeDestroy () {
    if (this.timeIntervals) {
      clearInterval(this.timeIntervals)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.tvu-iconfont .i-help .icon-a-help1{
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-drawer__body{
     &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 6px;
    }
}
  .cloudProxy .right .el-button--mini.is-round{
      padding:3px 14px;
      color:#FFF !important;
 }
.Version :not(:last-child){
  padding-top:3px;
  border-bottom:1px solid #555555;
  padding-bottom:5px;
  }
  .MediaServiceVersion{
    padding-top:3px;
  }
.header {
  .left {
    display: flex;
    align-items: center;
    .logoSvg {
      width: 32px;
      height: 32px;
      margin-right: 16px;
      float: left;
    }
    .logoText {
      font-weight: 700;
      font-size: 16px;
      line-height: 18px;
      color: #DBDBDB;
    }
  }
  .right {
    display: flex;
    align-items: center;
    .accountDivider, .netWorkTipDivider {
      height: 24px;
      background: #444;
      margin: 0 4px;
    }
    .helpCenter {
      height: 40px;
      width: 40px;
      justify-content: center;
    }
    .serviceList {
      margin-right: 26px;
      #tvu-service-jump-collect {
        width: 40px;
        height: 40px;
        line-height: 40px;
        justify-content: center;
        display: flex;
        align-items: center;
        /deep/.iconBtn {
          width: 44px;
          height: 44px;
        }
      }
    }
  }
}
</style>
